import { useEffect, useState } from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import './Backdrop.css';
import yoeshilabs from './assets/artworks/yoeshilabs.png';

type BackdropProps = {
  trackTitle: string;
  trackIndex: number;
  isPlaying: boolean;
  image: string;
  lyrics: string;
};

export const Backdrop = ({
  trackTitle,
  trackIndex,
  isPlaying,
  image,
  lyrics,
}: BackdropProps) => {
  useEffect(() => {
    document.documentElement.style.setProperty('--active-color', "#000000");
  }, [trackIndex]);
  

  return (
    <div className={`color-backdrop ${isPlaying ? 'playing' : 'idle'}`}>
      <img
          className="artwork2"
          src={image}
          alt=''
        />
    </div>
  );
};
